
import { defineComponent, ref } from "vue";

export default defineComponent({
  props: {
    html: {
      type: String,
      required: false,
    },
    isSuspended: {
      type: Boolean,
      required: false
    }
  },
  watch: { 
    isSuspended: function(isPaused) {
      if(isPaused) {
        window['_klarnaCheckout'](function (api) {
            api.suspend();
        });
      }
      else {
        window['_klarnaCheckout'](function (api) {
              api.resume();
        });
      }
    }
  },
  methods: {
    renderScript() {
      const checkoutContainer = document.getElementById('klarna-widget');

      if(checkoutContainer) {
        const scriptsTags = checkoutContainer.getElementsByTagName('script') ?? [];

        for (var i = 0; i < scriptsTags.length; i++) {
            var parentNode = scriptsTags[i].parentNode

            if(parentNode) {
              var newScriptTag = document.createElement('script');
              newScriptTag.type = 'text/javascript';
              newScriptTag.text = scriptsTags[i].text;
              parentNode.removeChild(scriptsTags[i]);
              parentNode.appendChild(newScriptTag);
            }
        }
      }
    }
  },
  mounted() {
    this.renderScript();
  }
});
